import { render, staticRenderFns } from "./direct-buy.vue?vue&type=template&id=91432276&scoped=true&"
import script from "./direct-buy.vue?vue&type=script&lang=js&"
export * from "./direct-buy.vue?vue&type=script&lang=js&"
import style0 from "./direct-buy.vue?vue&type=style&index=0&id=91432276&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91432276",
  null
  
)

export default component.exports